// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__ugBFh","head":"Table_head__35saS","col":"Table_col__2bTJY"};